/** @jsx jsx */
import { Grid, jsx } from "theme-ui"

import Contact from "./Contact"
import Section from "./Section"

function FooterNavigation({ links }) {
  // Create components for traversing nested structures and make it possible to pass UL and LI components

  return links ? (
    <nav aria-label="Footer navigation">
      <Grid
        as="ul"
        columns={["1fr", "repeat( auto-fit, minmax(100px, 1fr) )"]}
        gap={10}
        sx={{ listStyle: "none", m: 0, p: 0 }}
      >
        {links.items.map(({ href, slug, title, id, links, link }) => {
          return (
            <li key={id}>
              <Section
                href={href}
                links={links}
                slug={slug}
                title={title}
                link={link}
              />
            </li>
          )
        })}
        <li>
          <Contact />
        </li>
      </Grid>
    </nav>
  ) : null
}

export default FooterNavigation
